import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceSetStatusPayload } from 'api/actions/remote-source-set-status/remote-source-set-status-payload';
import { RemoteSourceSetStatusPathParameters } from 'api/actions/remote-source-set-status/remote-source-set-status-path-parameters';
import { RemoteSourceSetStatusResponse } from 'api/actions/remote-source-set-status/remote-source-set-status-response';

type RemoteSourceSetStatusQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceSetStatus action.
 */
export const remoteSourceSetStatusActionPath = new SweetPath<keyof RemoteSourceSetStatusPathParameters>(
  '/api/remote-source/status/{remoteSourceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceSetStatus actions.
 */
export default function createRemoteSourceSetStatusAction(axios: AxiosInstance) {
  return function remoteSourceSetStatusAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RemoteSourceSetStatusPathParameters;
    query?: RemoteSourceSetStatusQueryParameters;
    payload: RemoteSourceSetStatusPayload;
  }) {
    const path = remoteSourceSetStatusActionPath.insert(parameters);

    return axios.request<RemoteSourceSetStatusResponse, RemoteSourceSetStatusResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
